import { useState, useEffect, useCallback } from 'react';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';

export type UseDataTableSearchReturn = {
  query: string;
  setQuery: (query: string) => void;
  submit: (query: string) => void;
};

export const useDataTableSearch = (): UseDataTableSearchReturn => {
  const { tableState, setFilters } = useDataTableContext();
  const { query: contextQuery } = tableState;
  const [searchQuery, setSearchQuery] = useState(contextQuery ?? '');

  useEffect(() => {
    setSearchQuery(contextQuery ?? '');
  }, [contextQuery]);

  const submit = useCallback(
    (query: string): void => {
      setFilters({ query });
    },
    [setFilters]
  );

  return {
    query: searchQuery,
    setQuery: setSearchQuery,
    submit,
  };
};
